import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { XCircle } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-topacio-sand flex flex-col items-center justify-center px-6 py-10" data-testid="payment-cancel-page">
      <div className="text-center max-w-md card-brutal p-10">
        <XCircle className="w-14 h-14 text-topacio-red mx-auto" />
        <h1 className="font-display font-bold text-topacio-ink text-2xl mt-6">{t.pay.cancelled}</h1>
        <p className="text-topacio-faded mt-3">{t.pay.cancelledSub}</p>
        <Link to="/" data-testid="payment-cancel-home-btn" className="btn-primary mt-8">{t.pay.home}</Link>
      </div>
      <SiempriaCredit />
    </div>
  );
}
